import type { TabItem } from '@skupreme/shared/ui';

export const ORDER_TYPE_TABS: (TabItem & { pathPrefix: string })[] = [
  {
    id: 'D2C',
    label: 'D2C',
    href: '/app/orders/list/Pending%20Shipment/',
    pathPrefix: '/app/orders/list/',
  },
  {
    id: 'B2B',
    label: 'B2B',
    href: '/app/wholesale/invoices/list/all',
    pathPrefix: '/app/wholesale/invoices/list',
  },
];

export function getOrderTypeTabs(hiddenSections: string[] | undefined) {
  return ORDER_TYPE_TABS.filter(tab => !hiddenSections?.includes(tab.id));
}

/** Which tab the path is on; an unknown path selects nothing. */
export function getOrderTypeFromPath(pathname: string): string {
  const match = ORDER_TYPE_TABS.find(tab =>
    pathname.startsWith(tab.pathPrefix),
  );

  return match ? match.id : '';
}
